import moment from "moment-jalaali";
import "moment-timezone";
import {TIME_ZONE,TIME_ZONE_DATE} from "../Utils/CONSTANTS"
import {GetStorage} from "../Utils/Storage"

export function utcToLocalTime(time, format = "jYYYY/jM/jD HH:mm:ss") {
  const isDateValid = isValidMomentDate(time);
  if (!time || !isDateValid) {
    return null;
  }

  const cityName = getCityName()

  if (cityName.includes(TIME_ZONE.IRAN)) {
    const utc = moment.utc(time);
    return moment(utc).local().format(format);
  } else {
    return getDateByZone(time);
  }
};

export function utcToTime(time, format = "jYYYY/jM/jD HH:mm:ss") {
  const isDateValid = isValidMomentDate(time);
  console.log("time", time, isDateValid);
  if (!time || !isDateValid) {
    return null;
  }

  const cityName = getCityName();

  if (cityName.includes(TIME_ZONE.IRAN)) {
    const utc = moment.utc(time);
    return moment(utc).format(format);
  } else {
    return getDateByZone(time)
  }
}

export function utcToTimeIran(time, format = "jYYYY/jM/jD HH:mm") {
  const isDateValid = isValidMomentDate(time);
  if (!time || !isDateValid) {
    return null;
  }

  // Convert UTC time to Tehran time (Asia/Tehran timezone)
  const tehranTime = moment.utc(time).tz(TIME_ZONE_DATE["Asia/Tehran"]);

  // Check if time is not "0001-01-01 00:00:00" and format accordingly
  return tehranTime.format(format);
}

export function isValidDate(dateString) {
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date.getTime());
}

export function isValidMomentDate(dateString) {
  if (!dateString) return false
  return !moment(dateString).isSame("0001-01-01 00:00:00");
}
export const meterToHumanReadableDistance = (dis) => {
  const KM = Math.floor(dis / 1000);
  const M = Math.floor(dis - KM * 1000);

  if (Math.floor(KM) === 0 && Math.floor(M) === 0) {
    return `-`;
  }
  if (KM === 0) {
    return `${M}m`;
  }

  return `${KM}Km ${M}m`;
};

export function utcToHumanReadableTime(time) {
  const houres = Math.floor(time / 3600);
  const minutes = Math.floor(time / 60) - houres * 60;
  const seconds = time - minutes * 60 - houres * 3600;

  if (
      Math.floor(minutes) === 0 &&
      Math.floor(houres) === 0 &&
      Math.floor(seconds) === 0
  ) {
    return `-`;
  }
  if (Math.floor(minutes) === 0 && Math.floor(houres) === 0) {
    return `${Math.floor(seconds)}s`;
  }
  if (houres === 0) {
    return `${Math.floor(minutes)}m ${Math.floor(seconds)}s`;
  }
  return `${Math.floor(houres)}h ${Math.floor(minutes)}m ${Math.floor(
      seconds
  )}s`;
}

export function utcToHumanReadableClockTime(time) {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);

  if (hours === 0 && minutes === 0 && seconds === 0) return `-`;

  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export const keysToLowerCase = (obj) => {
  var keys = Object.keys(obj);
  var n = keys.length;
  var newobj = {};
  while (n--) {
    var key = keys[n];
    if (key === "FileData") {
      var childs = Object.keys(obj[key]);
      var count = childs.length;
      var newObject = {};
      while (count--) {
        var child = childs[count];
        newObject[child[0].toLowerCase() + child.slice(1)] = obj[key][child];
      }
      newobj[key[0].toLowerCase() + key.slice(1)] = newObject;
    } else {
      newobj[key[0].toLowerCase() + key.slice(1)] = obj[key];
    }
  }
  return newobj;
};

export const ConvertToHMSWithTag = (time) => {
  const splitedTime = time.split(":");
  if (splitedTime[0] !== "00")
    return `${splitedTime[0]}h, ${splitedTime[1]}m, ${splitedTime[2]}s`;
  if (splitedTime[1] !== "00") return `${splitedTime[1]}m, ${splitedTime[2]}s`;
  return `${splitedTime[2]}s`;
};

export const FaToEnDigits = (s) =>
    s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

const getCityName = () => GetStorage("cityName") || TIME_ZONE.IRAN;
const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone
const getDateByZone = (date) =>  new Date(date + "Z").toLocaleString("en-US",{
  timeZone:getTimeZone()
});